var view_num = window.screen.availWidth / 750;
document
  .getElementById('viewport')
  .setAttribute(
    'content',
    'user-scalable=no, width=750, minimum-scale=' +
      view_num +
      ', initial-scale=' +
      view_num +
      ', maximum-scale=' +
      view_num +
      ''
  );
